const FromArr = [
  {
    title: "标题",
    modelvalue: "",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#424E66",
    lableheight: 0,
    lablewidth: 80,
    types: "text",
    placeholder: "请输入标题",
    width: 400,
    height: 32,
    disabled: false,
    marginLeft: 20,
    marginTop: 0,
    X: false,
    displayVal: "inline-block",
    fontWeightVal: 500
  },
  {
    title: "内容",
    modelvalue: "",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#424E66",
    lableheight: 0,
    lablewidth: 80,
    types: "textarea",
    placeholder: "请输入内容",
    width: 400,
    height: 100,
    disabled: false,
    marginLeft: 20,
    marginTop: 20,
    X: false,
    displayVal: "inline-block",
    fontWeightVal: 500
  }
];
export default FromArr;
